import { fetchPage, fetchDatePage } from '../apis/api';

export interface PageArticle {
  index: string;
  date: string;
  title: string;
  coords: string[];
  json: string;
}

export interface PageData {
  index?: string;
  title?: string;
  date: string;
  page: string;
  image?: string;
  width?: number;
  height?: number;
  articles?: PageArticle[];
}

const baseUrl = process.env.EPAPER_BASE_URL;

export const setPageDataList: PageData[] = [
  { date: '2025-11-09', page: 'A1', title: '头版' },
  {
    date: '2025-11-09',
    page: 'A2',
    title: '牢记总书记嘱托 不断取得现代化建设新成效',
  },
  {
    date: '2025-11-09',
    page: 'A3',
    title: '牢记总书记嘱托 不断取得现代化建设新成效',
  },
  {
    date: '2025-11-09',
    page: 'A4',
    title: '牢记总书记嘱托 不断取得现代化建设新成效',
  },
  {
    date: '2025-11-09',
    page: 'A5',
    title: '牢记总书记嘱托 不断取得现代化建设新成效',
  },
  { date: '2025-11-09', page: 'A6', title: '激情全运会 活力大湾区' },
  { date: '2025-11-09', page: 'A7', title: '激情全运会 活力大湾区' },
  { date: '2025-11-09', page: 'A8', title: '办好一个会 提升一座城' },
  { date: '2025-11-09', page: 'A10', title: '学习贯彻党的二十届四中全会精神' },
  { date: '2025-11-09', page: 'A11', title: '学习贯彻党的二十届四中全会精神' },
  { date: '2025-11-09', page: 'A12', title: '激情全运会 活力大湾区' },
  { date: '2025-11-09', page: 'T1', title: '湾区好运' },
  { date: '2025-11-09', page: 'T5', title: '湾区好运' },
  { date: '2025-11-09', page: 'A13', title: '激情全运会 活力大湾区' },
  { date: '2025-11-09', page: 'A14', title: '激情全运会 活力大湾区' },
  { date: '2025-11-09', page: 'A15', title: '激情全运会 活力大湾区' },
  { date: '2025-11-09', page: 'A16', title: '粤韵周刊' },
  { date: '2025-11-09', page: 'A18', title: '激情全运会 活力大湾区' },
  { date: '2025-11-09', page: 'A19', title: '激情全运会 活力大湾区' },
  { date: '2025-11-09', page: 'A20', title: '激情全运会 活力大湾区' },
  { date: '2025-11-09', page: 'A21', title: '激情全运会 活力大湾区' },
  { date: '2025-11-09', page: 'A22', title: '激情全运会 活力大湾区' },
  { date: '2025-11-09', page: 'A23', title: '激情全运会 活力大湾区' },
  { date: '2025-11-09', page: 'A24', title: '激情全运会 活力大湾区' },
  { date: '2025-11-09', page: 'A25', title: '激情全运会 活力大湾区' },
  { date: '2025-11-09', page: 'A26', title: '激情全运会 活力大湾区' },
  { date: '2025-11-09', page: 'A27', title: '激情全运会 活力大湾区' },
  { date: '2025-11-09', page: 'A28', title: '激情全运会 活力大湾区' },
];

export const defaultPageWidth = 1024;
export const defaultPageHeight = 1463;

/**
 * 加载页面数据。
 * @param begin 开始加载时的回调函数，接收一个参数，表示加载的进度。
 * @param progress 加载过程中每次进度更新时的回调函数。
 * @returns 返回一个Promise，解析为PageData数组。
 */
export const loadPageData = (
  begin: (num: number) => any,
  progress: () => any
): Promise<PageData[]> => {
  // 生成唯一的日期列表
  const dateList = Array.from(
    new Set(setPageDataList.map((item) => item.date))
  );
  // 生成图片地址列表
  const imageList = setPageDataList.map(
    (setPageData) =>
      setPageData.image ||
      `${baseUrl}/pc/wxapp/resfile/${setPageData.date}/${setPageData.page}/Page_h.jpg`
  );

  // 为每个图片地址创建一个Promise，加载图片并更新进度
  const imagePromises: Promise<HTMLImageElement>[] = imageList.map(
    (src) =>
      new Promise((resolve, reject) => {
        const image = new Image();
        image.src = src;
        image.onload = () => {
          progress();
          resolve(image);
        };
        image.onerror = () => {
          reject(new Error('fail image'));
        };
        if (image.complete) {
          progress();
          resolve(image);
        }
      })
  );

  // 创建所有需要加载的Promise，包括日期数据、页面数据和图片加载
  const promises = [
    ...imagePromises,
    ...dateList.map(
      (date) =>
        new Promise((resolve) => {
          fetchDatePage(date).then((res) => {
            progress();
            resolve(res);
          });
        })
    ),
    ...setPageDataList.map(
      (page) =>
        new Promise((resolve) => {
          fetchPage(page.date, page.page).then((res) => {
            progress();
            resolve(res);
          });
        })
    ),
  ];

  // 开始加载，通知调用方进度
  begin(promises.length);

  try {
    // 等待所有Promise完成，然后解析结果
    return new Promise((resolve) => {
      Promise.all(promises)
        .then((reslist) => {
          const result: PageData[] = [];
          const dateResList: Epaper.Date[] = [];
          const datePageResList: Epaper.PageJson[] = [];
          const imageResList: HTMLImageElement[] = [];

          // 解析结果，分类整理
          reslist.forEach((res) => {
            if ((res as Epaper.Date)['版次列表']) {
              dateResList.push(res as Epaper.Date);
            } else if ((res as Epaper.PageJson)['文章']) {
              datePageResList.push(res as Epaper.PageJson);
            } else if ((res as HTMLImageElement).src) {
              imageResList.push(res as HTMLImageElement);
            }
          });

          // 根据整理的数据，生成PageData数组
          let imageIndex = 0;
          dateResList.forEach((dateRes) => {
            // dateRes['版次列表'].forEach((page) => {
            //   const setPageData = setPageDataList.find(
            //     (item) =>
            //       item.date === dateRes['日期'] && item.page === page['版次']
            //   );
            //   const remotePageData = datePageResList.find(
            //     (item) =>
            //       item['日期'] === dateRes['日期'] &&
            //       item['版次'] === page['版次']
            //   );
            //   const image = imageResList[imageIndex];
            //   if (setPageData && remotePageData && image) {
            //     imageIndex += 1;
            //     result.push({
            //       index: setPageData.index || page['版次'],
            //       title: setPageData.title || page['版名'],
            //       date: setPageData.date,
            //       page: setPageData.page,
            //       image: image.src,
            //       width: image.naturalWidth,
            //       height: image.naturalHeight,
            //       articles:
            //         setPageData.articles ||
            //         remotePageData['文章'].map((article) => ({
            //           index: article['序号'],
            //           date: dateRes['日期'],
            //           title: article['标题'],
            //           coords: article['版面图映射']['顶点'].map(
            //             (coord: string) => {
            //               const [percentX, percentY] = coord.split(',');
            //               const x =
            //                 (parseFloat(percentX) / 100) * image.naturalWidth;
            //               const y =
            //                 (parseFloat(percentY) / 100) * image.naturalHeight;
            //               return [Math.ceil(x), Math.ceil(y)].join(',');
            //             }
            //           ),
            //           json: article.json,
            //         })),
            //     });
            //   }
            // });
            setPageDataList.forEach((setPageData) => {
              const page = dateRes['版次列表'].find(
                (item) =>
                  setPageData.date === dateRes['日期'] &&
                  setPageData.page === item['版次']
              );
              if (!page) return;
              const remotePageData = datePageResList.find(
                (item) =>
                  item['日期'] === dateRes['日期'] &&
                  item['版次'] === page?.['版次']
              );
              const image = imageResList[imageIndex];
              if (setPageData && remotePageData && image) {
                imageIndex += 1;
                result.push({
                  index: setPageData.index || page?.['版次'],
                  title: setPageData.title || page?.['版名'],
                  date: setPageData.date,
                  page: setPageData.page,
                  image: image.src,
                  width: image.naturalWidth,
                  height: image.naturalHeight,
                  articles:
                    setPageData.articles ||
                    remotePageData['文章'].map((article) => ({
                      index: article['序号'],
                      date: dateRes['日期'],
                      title: article['标题'],
                      coords: article['版面图映射']['顶点'].map(
                        (coord: string) => {
                          const [percentX, percentY] = coord.split(',');
                          const x =
                            (parseFloat(percentX) / 100) * image.naturalWidth;
                          const y =
                            (parseFloat(percentY) / 100) * image.naturalHeight;
                          return [Math.ceil(x), Math.ceil(y)].join(',');
                        }
                      ),
                      json: article.json,
                    })),
                });
              }
            });
          });
          resolve(result);
        })
        .catch((e) => {
          console.error(e);
        });
    });
  } catch (e) {
    console.error(e);
    return Promise.reject(e);
  }
};
